const validationKeysEN = {
  translation: {
    "v-key-username": "Username",
    "v-key-email": "Email",
    "v-key-firstName": "First name",
    "v-key-middleName": "Middle name",
    "v-key-lastName": "Last name",
    "v-key-personalId": "Personal identifier",
    "v-key-dateOfBirth": "Date of birth",
    "v-key-representedUniversity": "Represented university",
    "v-key-representativeCapacity": "Representative capacity",
    "v-key-password": "Password",
    "v-key-confirmPassword": "Confirm password",
    "v-key-representedCompany": "Represented company (UIC)",
    "v-key-birthPlace": "Birth place",
    "v-key-birthCountry.id": "Birth country",
    "v-key-contactAddress.city": "Settlement (Contact address)",
    "v-key-contactAddress.postCode": "Post code (Contact address)",
    "v-key-contactAddress.address": "Address (Contact address)",
    "v-key-contactAddress.phone": "Phone (Contact address)",
    "v-key-contactAddress.postBox": "Post box (Contact address)",
    "v-key-contactAddress.email": "Email (Contact address)",
    "v-key-contactAddress.fax": "Fax (Contact address)",
    "v-key-receiverAddress.city": "Settlement (Receiver address)",
    "v-key-receiverAddress.postCode": "Post code (Receiver address)",
    "v-key-receiverAddress.address": "Address (Receiver address)",
    "v-key-receiverAddress.phone": "Phone (Receiver address)",
    "v-key-receiverAddress.name": "Receiver name (Receiver address)",
    "v-key-birthSettlement.id": "Birth settlement",
    "v-key-foreignerIdentifierKind.id": "Foreigner identifier kind",
    "v-key-foreignerIdentifierCountry.id": "Foreigner identifier country",
    "v-key-citizenship.id": "Citizenship",
    "v-key-title": "Title",
  },
};

export default validationKeysEN;
